import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/HASHID/HASHID_01.png";
import Img_Two from "./../../../../sources/imgs/HASHID/HASHID_02.png"
import Img_Three from "./../../../../sources/imgs/HASHID/HASHID_03.png";
import Img_Four from "./../../../../sources/imgs/HASHID/HASHID_04.png";
import Img_Five from "./../../../../sources/imgs/HASHID/HASHID_05.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function HASHID (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> HASHID.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a HashId.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">HashID</span> es una <span className="span-white">herramienta de línea de comandos</span> escrita en <span className="span-pink">Python</span> que sirve para <span className="span-white">identificar tipos de hashes</span> a partir de sus <span className="span-pink">valores</span>. En el <span className="span-pink">hacking ético</span>, es útil para saber con qué <span className="span-white">algoritmo fue cifrada una contraseña</span> o un <span className="span-white">archivo</span>, permitiendo así elegir la herramienta adecuada para intentar romperlo (ej. con <span className="span-blue">Hashcat</span> o <span className="span-blue">John the Ripper</span>).
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Caracteristicas de HashId.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">HashId</span> tiene <span className="span-pink">caracteristicas</span> como las <span className="span-white">siguientes</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        Detecta <span className="span-white">múltiples tipos de hashes</span> (<span className="span-blue">MD5</span>, <span className="span-blue">SHA-1</span>, <span className="span-blue">SHA-256</span>, etc.).
                    </p>
                </li>
                <li>
                    <p>
                        Soporta <span className="span-white">hash simples</span> y <span className="span-white">combinados</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">Fácil de usar</span> desde <span className="span-pink">consola</span>.
                    </p>
                </li>
                <li>
                    <p>
                        Puede <span className="span-pink">mostrar</span> <span className="span-pink">todos los algoritmos compatibles</span> con la <span className="span-blue">longitud del hash</span>, o <span className="span-blue">el más probable</span>.
                    </p>
                </li>
            </ul>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Instalación de HashId.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para la <span className="span-white">Instalación</span> de la <span className="span-white">herramienta</span> <span className="span-yellow">HashId</span> debemos <span className="span-white">ejecutar</span> el <span className="span-pink">siguiente comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install hashid"
            />

            <p>
                Tal como se muestra en la <span className="span-white">siguiente imagen</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. HASHID."}
                title = {"Descripcción de imagen."}
                text = {"1. Comando de instalación de HASHID."}
            />

            <p>
                O bien, <span className="span-white">descargar su repositorio</span> y <span className="span-pink">ejecutarlo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "git clone https://github.com/psypanda/hashID.git"
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "cd hashID"
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "python3 hashid.py -h"
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Versión de HashId.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Podemos <span className="span-pink">verificar</span> su <span className="span-blue">instalación</span> y <span className="span-b">version</span> de <span className="span-yellow">HashId</span> ejecutando el <span className="span-white">siguiente comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "hashid --v"
            />

            <p>
                Como en la <span className="span-white">siguiente imagen</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. HASHID."}
                title = {"Descripción de imagen."}
                text = {"2. Comando de versión de HASHID."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Información y ayuda de HashId.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para <span className="span-pink">obtener</span> <span className="span-white">información</span> y <span className="span-white">ayuda</span> de la herramienta podemos ejecutar el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "hashid --help"
            />

            <p>
                Mostrando:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. HASHID."}
                title = {"Descripción de imagen."}
                text = {"3. Comando de ayuda de HASHID."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Uso de HashId.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para el uso de <span className="span-yellow">HashId</span>, basta con <span className="span-pink">ejecutar el comando base</span>, acompañado del <span className="span-white">hash a decifrar</span>.
            </p>

            <p>
                Tal como la <span className="span-white">siguiente estructura</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "hashid <hash>"
            />

            <p>
                Un <span className="span-white">ejemplo</span> de <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "hashid e10adc3949ba59abbe56e057f20f883e"
            />

            <p>
                Tal como el <span className="span-white">siguiente ejemplo</span>:
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. HASHID."}
                title = {"Descripción de imagen."}
                text = {"4. Comando de uso de HASHID."}
            />

            <p>
                Devolviendo los <span className="span-pink">posibles tipos de hash</span> los cuales puedan ser utiles.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Parametros utiles de HashId.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">HashId</span> tambien nos ofrece <span className="span-pink">parametros</span> que pueden enriquecer la <span className="span-white">información del comando</span> ejecutado.
            </p>

            <p>
                <span className="span-white">Algunos</span> de ellos son:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-white"> -e</i> <span className="span-blue">-></span> <span className="span-pink">Muestra todos los posibles algoritmos de hash, incluyendo aquellos que usan salts (salados). A veces un hash no es puro (como MD5 simple), sino que está combinado con una "sal" para hacerlo más difícil de romper. Esta opción te muestra esos posibles algoritmos también.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white"> -m</i> <span className="span-blue">-></span> <span className="span-pink">Muestra el modo correspondiente de Hashcat para el tipo de hash. Si vas a usar Hashcat para crackear el hash, necesitas el número de modo correcto (-m). Esto te lo da directamente HashID.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white"> -j</i> <span className="span-blue">-></span> <span className="span-pink">Muestra el formato correspondiente para John the Ripper, otra herramienta de crackeo de hashes. John necesita que le indiques el tipo de hash usando su propio formato. Este flag te dice cuál usar.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white"> -o</i> <span className="span-white">&lt;archivo&gt;.txt</span> <span className="span-blue">-></span> <span className="span-pink">Muestra el formato correspondiente para John the Ripper, otra herramienta de crackeo de hashes. John necesita que le indiques el tipo de hash usando su propio formato. Este flag te dice cuál usar.</span>
                    </p>
                </li>
            </ul>

            <p>
                Mostremos un <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "hashid -e -m -j -o resultados.txt e10adc3949ba59abbe56e057f20f883e"
            />

            <p>
                Tal como el <span className="span-white">siguiente ejemplo</span>:
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. HASHID."}
                title = {"Descripción de imagen."}
                text = {"5. Comando con parametros extra de HASHID."}
            />
        </>
    );
}